import { Injectable } from '@angular/core';
import { AuthClientHelper } from '../helpers/auth/auth-client.helper';
import { environment } from '../../../environments/environment';
import {IResourceActionInner, IResourceResponse, Resource} from '@ngx-resource/core';
import { ResourceHandler } from '@ngx-resource/core/src/ResourceHandler';
import {HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {SpinnerHelper} from '../helpers/spinner/spinner.helper';
import {Observable} from 'rxjs/Observable';
import {ToastrService} from 'ngx-toastr';

/**
 Generated class for the BaseService.
 */

 @Injectable()
 export class BaseService extends Resource implements HttpInterceptor {
    public static BASE_URL = environment.apiUrl;

    constructor(requestHandler: ResourceHandler,
        protected _auth: AuthClientHelper,
        private toastr: ToastrService,
        protected http: HttpClient) {
        super(requestHandler);
    }

    $getHeaders(methodOptions: any): any {
        let headers = super.$getHeaders();

        // Extending our headers with Authorization
        if (!methodOptions.skipAuthorization) {
            headers = this._auth.extendHeaders(headers);
        }

        return headers;
    }

    $handleSuccessResponse(options: IResourceActionInner, resp: IResourceResponse) {
        if (options.actionOptions.returnRaw) {
            return resp;
        }
        return resp.body;
    }

    $handleErrorResponse(options: IResourceActionInner, err: IResourceResponse) {
        SpinnerHelper.displayLoader(false);
        if (err && err.body) {
            let errorMsg = '';

            if(err.status == 422){
                this.toastr.warning('Formato de Dados inválido.', 'Erro..');
            }else{
                if(err.status == 500){
                    this.toastr.warning('Contate o administrador.', 'Erro...');
                }else{
                    if(err.status == 404){
                        this.toastr.warning('Serviço não encontrado.', 'Erro...');
                    } else {
                        if ((options.actionOptions.path = '/send-text') && (err.status == 503)) {
                            this.toastr.error('Ocorreu um problema ao enviar a mensagen.', 'Erro...');
                        } 
                        else if ((options.actionOptions.path = '/send-text-to-many') && (err.status == 503)) {
                            this.toastr.error('Ocorreu um problema ao enviar as mensagens.', 'Erro...');
                        } 

                        this.toastr.error(err.body.message, 'Erro...');
                    }
                }
            }
            

            /*if (err.body.error && err.body.error[0] && err.body.error[0].field) {
                errorMsg = err.body.error.map(function (e) {
                    return e.message;
                }).join('\n');
            } else if (err.body.error && err.body.error[0]) {
                errorMsg = err.body.error.join('\n');
            } else if (err.body.message) {
                errorMsg = err.body.message;
            } else {
                errorMsg = 'Ocorreu um erro';
            }*/
        }
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    SpinnerHelper.displayLoader(false);
                } else {
                    if (!SpinnerHelper.manualText) {
                      SpinnerHelper.displayLoader(true, 'Processando. Por favor aguarde...');
                    }
                }
            }, (err: any) => {
                console.error(err);
                SpinnerHelper.displayLoader(false);
            }));
    }

}



// WEBPACK FOOTER //
// ./src/app/core/api/base.service.ts